<template>
  <div>
    <label
      :for="`input-${fieldProperties.key}`"
      :style="styleProperty"
      :class="fieldProperties.required ? 'required' : null"
    >
      {{
        $i18n.locale == 'th'
          ? fieldProperties.label_th
          : fieldProperties.label_en
      }}
    </label>
    <b-form-textarea
      :id="`input-${fieldProperties.key}`"
      :placeholder="
        $i18n.locale == 'th'
          ? fieldProperties.placeholder_th
          : fieldProperties.placeholder_en
      "
      :required="fieldProperties.required || textAreaField.required"
      :maxlength="fieldProperties.field_property.maxlength"
      :rows="fieldProperties.field_property.row"
      :max-rows="fieldProperties.field_property.max_row"
      :readonly="fieldProperties.readonly || textAreaField.readonly"
      :style="fieldStyleProperty"
      v-model="fieldValue"
      class="textbox-input"
    />
  </div>
</template>

<script>
  import { BFormTextarea } from 'bootstrap-vue';
  import { computed, ref, watch } from '@vue/composition-api';
  import { textAreaField } from '@/configs/dynamic-config/dynamic-field';

  export default {
    components: { BFormTextarea },
    props: { fieldProperties: Object },

    setup(props) {
      const fieldValue = ref(props.fieldProperties.value || null);

      const styleProperty = computed(() => {
        return {
          color:
            props.fieldProperties.field_property.color_font ||
            textAreaField.color_font,
          fontSize:
            props.fieldProperties.field_property.font_size ||
            textAreaField.fontSize,
        };
      });

      const fieldStyleProperty = computed(() => {
        return {
          color:
            props.fieldProperties.field_property.color_font ||
            textAreaField.color_font,
          fontSize:
            props.fieldProperties.field_property.font_size ||
            textAreaField.fontSize,
          width:
            props.fieldProperties.field_property.width || textAreaField.width,
        };
      });

      watch(
        () => props.fieldProperties.value,
        () => {
          fieldValue.value = props.fieldProperties.value;
        },
        { deep: true }
      );

      return { styleProperty, textAreaField, fieldStyleProperty, fieldValue };
    },
  };
</script>

<style></style>

<style scoped>
  @import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
